module.exports = __webpack_public_path__ + "img/success.d30dee6f.svg";